import axios from "../axios";

const getActivityLogs = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('/log-activity/getActivityLogs', params ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getActivityLogs;
